/**
* Created by iraphael on 12/21/18.
*/

define(function (require) {

    var _ = require('underscore');
    var BaseFilterItem = require('web-agent-components/BaseFilterItemViewController');
    var TagsContainer = require("ui/tags-container/TagsContainer");

    var FilterItemMultiTextInputViewController = BaseFilterItem.extend({
        ControllerName: 'FilterItemMultiTextInputViewController',

        LPTemplatesFiles: {
            textInputItem: "LP_filter_full_table_multi_text_input.html"
        },
        LPElementsMap: {
            textInput: "input",
        },
        LPViewMap: {
            tagsContainer: ".lpview_tagsContainer"
        },

        initialize: function(constructorData) {
            this.tagsContainerEnabled  = constructorData.tagsContainerEnabled;
            this.separator = constructorData.separator;
            this.maxShownLines = constructorData.maxShownLines || 0;

            this.viewInit();

        },
        events: function() {
            this.tagsContainer.on(TagsContainer.TRIGGERING.INPUT_CREATE, this._onItemAddedInCollection, this);
            this.tagsContainer.on(TagsContainer.TRIGGERING.TAG_REMOVE, this._onItemRemovedFromCollection, this);
        },

        render: function() {
            this.tagsContainer.render();
        }
    });

    FilterItemMultiTextInputViewController.prototype.viewInit = function() {
        var tableTemplate = require('web-agent-templates/' + this.LPTemplatesFiles.textInputItem);
        this.createView({template: tableTemplate});
        var tagsContainer = this.getFirstElement(this.LPViewMap.tagsContainer);
        var tagsContainerConfigData = {
            el: $(tagsContainer),
            maxShownLines: this.maxShownLines,
            inlineErrorText: "",
            tagMaxWidth: "150px",
            tagCreationEnabled: true,
            separator: this.separator,
            closeable: true,
            enabled: this.tagsContainerEnabled
        };

        this.tagsContainer = new TagsContainer(tagsContainerConfigData);
    };

    FilterItemMultiTextInputViewController.prototype.toggleFilterItem = function (enable) {
        this.tagsContainer.setEnabled(enable);
    };

    FilterItemMultiTextInputViewController.prototype._onItemAddedInCollection = function(value) {
        var trimValue = $.trim(value.value); // left and right trim the keyword
        if (trimValue.length > 0) { // make sure keyword is not empty
            this.tagsContainer.addItem(this._mapItemModelToTagContainerObj(trimValue));
            this.tagsContainer.clearInputValue();
            this.tagsContainer.setFocus();
        }
    };

    FilterItemMultiTextInputViewController.prototype._mapItemModelToTagContainerObj = function (value){
        return {
            id: value,
            value: value
        };
    };

    FilterItemMultiTextInputViewController.prototype._onItemRemovedFromCollection = function(value) {
        this.tagsContainer.removeItem(value);
    };

    FilterItemMultiTextInputViewController.prototype.getValue = function() {
        if(this.tagsContainer.isEnabled()) {
            var results =  this.tagsContainer.getItems().map(mapValuesFromTag);
            return (results.length) > 0 ? results.toString() : undefined;
        }

        function mapValuesFromTag(tagItem) {
            return tagItem.value;
        }
    };

// set the tags and dropdown according to the data in the filter
    FilterItemMultiTextInputViewController.prototype.updateFilterUI = function (filterUIData) {
        this.tagsContainer.clearItems();
        if (filterUIData) {
            var list = filterUIData.split(",");
            for (var i = 0; i < list.length; ++i) {
                var trimValue = $.trim(list[i]); // left and right trim the keyword
                if (trimValue.length > 0) { // make sure keyword is not empty
                    this.tagsContainer.addItem(this._mapItemModelToTagContainerObj(trimValue));
                }
            }
        }
    };

    return FilterItemMultiTextInputViewController;

});
